import constants from '@core/utils/constants';
import { bus } from '@core/events/eventSystem';
import { getStore } from '@core/store';
import { serializer } from './serializer';

bus.on(constants.EVENTS.CUSTOMERS.LIST_ALL.REFRESH, ({ page } = {}) => {
  const requestId = `listAllTransactions-${Date.now()}`;
  const limit = 100;
  const pageToUse = parseInt(page || 0);

  const userStore = getStore('user');
  let url = `${constants.ENDPOINTS.CUSTOMERS.GET_LIST}`;
  url = url.replace('{userId}', userStore.state.current.id);
  url = url.replace('{offset}', pageToUse * limit);
  url = url.replace('{limit}', limit);

  bus.emit(EVENTS.CUSTOMERS.LIST_ALL.REFRESHING);
  bus.emit(constants.EVENTS.NETWORK.REQUEST, {
    id: requestId,
    url,
    method: 'GET',
    data: {}
  });

  const handler = (res) => {
    if (res.id === requestId) {
      bus.off(constants.EVENTS.NETWORK.RESPONSE, handler);
      const parsed = serializer.deserialize(res);
      if (parsed.success) {
        bus.emit(EVENTS.CUSTOMERS.LIST_ALL.REFRESHED, parsed.data);
      } else {
        bus.emit(EVENTS.CUSTOMERS.LIST_ALL.REFRESH_ERROR, parsed);
      }
    }
  };
  bus.on(constants.EVENTS.NETWORK.RESPONSE, handler);
});

bus.on(constants.EVENTS.CUSTOMERS.DETAIL.REFRESH, (data) => {
  console.log("🚀 ~ data:", data)
  if (!data?.id) return;
  const requestId = `transactionDetail-${Date.now()}`;
  bus.emit(EVENTS.CUSTOMERS.DETAIL.REFRESHING);
  const url = `${constants.ENDPOINTS.CUSTOMERS.GET_DETAIL}`.replace(
    /{id}/,
    data?.id
  );
  bus.emit(constants.EVENTS.NETWORK.REQUEST, {
    id: requestId,
    url: url,
    method: 'GET',
    data: {}
  });

  bus.on(constants.EVENTS.NETWORK.RESPONSE, (res) => {
    if (res.id === requestId) {
      const parsed = serializer.deserializeTransactoinDetail(res);
      if (parsed.success) {
        bus.emit(EVENTS.CUSTOMERS.DETAIL.REFRESHED, parsed.data);
      } else {
        bus.emit(EVENTS.CUSTOMERS.DETAIL.REFRESH_ERROR, parsed);
      }
    }
  });
});
